import { render, staticRenderFns } from "./AddOrderToTruckModal.vue?vue&type=template&id=ec7a40d8&scoped=true"
import script from "./AddOrderToTruckModal.vue?vue&type=script&lang=js"
export * from "./AddOrderToTruckModal.vue?vue&type=script&lang=js"
import style0 from "./AddOrderToTruckModal.vue?vue&type=style&index=0&id=ec7a40d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7a40d8",
  null
  
)

export default component.exports